export const ALL_FILES_PAGE = "ALL_FILES_PAGE";
export const GOOGLE_PAGE = "GOOGLE_PAGE";
export const WHATSAPP_PAGE = "WHATSAPP_PAGE";
export const DROPBOX_PAGE = "DROPBOX_PAGE";
export const MAIL_PAGE = "MAIL_PAGE";
export const EXTENSION_PAGE = "EXTENSION_PAGE";
export const CALENDER_PAGE = "CALENDER_PAGE";
export const GALLERY_PAGE = "GALLERY_PAGE";
export const CLEAR_PAGE = "CLEAR_PAGE";
